import unlockedFeaturesFullNames from "../datasets/unlocked_features_full_names";
import determineNbrUnlockedLevels from "./determine_nbr_unlocked_levels";
import getUnlockedFeatureCriteria from "../objectsStatus/get_unlocked_feature_criteria";
import buildFeatureTextArr from "../objectsStatus/build_feature_text_arr";
import determineMinimumPercentEarned from "./determine_minimum_percent_earned";
import calculateJobSalary from "../../../objects/AssetsExpenses/calculate_job_salary";
import determineUnlockedFeatureLevels from "./determine_unlocked_feature_levels";
import buildProgressDashArr from "./build_progress_dash_arr";

export const createUnlockedFeatureRoadmapArr = (unlockedFeatures, gameNbrMonths, currentCash,
    savingsInfo, monthlyIncome, creditReportObj, assetTable, gameDate, 
    summaryInvestment, funStuff, creditCardInfo, timeWizardInfo, eligible)=> {
        const nbrDashesArr = determineNbrUnlockedLevels();
        const currentLevelArr = determineUnlockedFeatureLevels(savingsInfo, summaryInvestment, funStuff, 
            creditCardInfo, timeWizardInfo)
        const annualSalary = calculateJobSalary(assetTable, gameDate, false, "annual");
        let unlockedFeatureRoadmapArr = [];
        for (let i=0; i<unlockedFeaturesFullNames.length; i++){
            const featureName = unlockedFeaturesFullNames[i].featureName;
            const featureDisplayName = unlockedFeaturesFullNames[i].fullName;
            const featureImgSrc = unlockedFeaturesFullNames[i].imgSrc;
            const currentFeatureObj = unlockedFeatures.find(elem => elem.featureName === featureName);
            let featureLevel = 0;
            let featureStatus = "none";
            if (currentFeatureObj){
                featureLevel = currentFeatureObj.level;
                featureStatus = currentFeatureObj.setup;
            }
            let currentLevel = currentLevelArr.find(elem => elem.featureName === featureName).level;
            if (!currentLevel){
                currentLevel = 0;
            }
            const featureCriteriaObj = getUnlockedFeatureCriteria(featureName, featureLevel, featureStatus);
            let featureCriteria = featureCriteriaObj.featureCriteria;
            const featureTextObj = buildFeatureTextArr(featureCriteria, gameNbrMonths,
                currentCash, savingsInfo, monthlyIncome, creditReportObj, annualSalary, 
                eligible);
            const featureCriteriaArr = featureTextObj.featureCriteriaArr;
            const nbrDashes = nbrDashesArr.find(elem => elem.featureName === featureName).nbrLevels;
            //  determine the lowest percent for all feature criteria for the 'featureLevel';
            const lowestPercentEarned = determineMinimumPercentEarned(featureCriteriaArr);
            const progressDashArr = buildProgressDashArr(currentLevel, lowestPercentEarned, nbrDashes);
            const featureLevelDiff = +featureLevel - +currentLevel;
            let opacity = 2;
            if (+currentLevel > 1){
                opacity = "100%";
            }else{
                if (+currentLevel === 1 && +lowestPercentEarned === 100){
                    opacity = "100%"
                }else{
                    opacity = (+lowestPercentEarned * 100).toFixed(2) + "%";
                }
            }
            let earnedMore = false;
            if (featureLevelDiff > 1){
                earnedMore = true;
            }else{
                if (featureLevelDiff === 1 && lowestPercentEarned === 100){
                    earnedMore = true;
                }
            }
            const featureRoadMapObj = {nbr: i + 1, nbrDashes: nbrDashes, displayName: featureDisplayName,
                imgSrc: featureImgSrc, opacity: opacity, progressDashArr: progressDashArr,
                currentLevel: currentLevel, earnedMore: earnedMore, featureName: featureName
            }
            unlockedFeatureRoadmapArr.push(featureRoadMapObj);
        }
        return unlockedFeatureRoadmapArr;

}
export default createUnlockedFeatureRoadmapArr;

          